"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATHS_BY_ROLE = exports.STUDENT_PATHS = exports.TEACHER_PATHS = exports.ADMIN_PATHS = exports.STUDENT_BASE_PATH = void 0;
var ripl_core_1 = require("@greatmindsorg/ripl-core");
exports.STUDENT_BASE_PATH = '/assessments/student';
exports.ADMIN_PATHS = [
    { label: 'Resources', path: '/teacher' },
    { label: 'Assessments', path: '/assessments/admin/library' },
    { label: 'Reports', path: '/reports' },
];
// Teacher, Admins and similar roles
exports.TEACHER_PATHS = [
    { label: 'Resources', path: '/teacher' },
    { label: 'Assessments', path: '/assessments/teacher/home' },
    { label: 'Reports', path: '/reports' },
];
exports.STUDENT_PATHS = [
    { label: 'My Work', path: '/home' },
    { label: 'My Scores', path: '/reports' },
    { label: 'Resources', path: '/library' },
];
exports.PATHS_BY_ROLE = (_a = {},
    _a[ripl_core_1.user.Role.Student] = exports.STUDENT_PATHS,
    _a[ripl_core_1.user.Role.Teacher] = exports.TEACHER_PATHS,
    _a[ripl_core_1.user.Role.SchoolAdmin] = exports.ADMIN_PATHS,
    _a[ripl_core_1.user.Role.GmSuperAdmin] = exports.ADMIN_PATHS,
    _a[ripl_core_1.user.Role.DistrictAdmin] = exports.ADMIN_PATHS,
    _a);
